import React from "react";

export default function Terms({ todayDate, userData, selectedContract }) {
  return (
    <>
      <p
        style={{
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "15px",
        }}
      >
        TERMO ADITIVO AO CONTRATO DE PARTICIPAÇÃO EM OPERAÇÕES MINERAIS – CPOM
      </p>

      <p>
        Pelo presente TERMO ADITIVO ao CONTRATO DE PARTICIPAÇÃO EM OPERAÇÕES
        MINERAIS – CPOM, celebrado entre as mesmas PARTES já qualificadas no
        instrumento principal, resolvem, de comum acordo, ajustar, complementar
        e detalhar os modelos de divisão, acúmulo e disponibilidade dos
        royalties, nos termos abaixo descritos, permanecendo inalteradas todas
        as demais cláusulas do contrato original.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        CLÁUSULA PRIMEIRA – DO OBJETO DO TERMO ADITIVO
      </p>

      <p>
        1.1. O presente Termo Aditivo tem por objeto disciplinar e organizar os
        modelos de divisão, acúmulo e saque dos royalties comerciais com a
        “CAIXA DE OURO GOLDEN BOX”, para o ADQUIRENTE nas operações minerais
        administradas pela VENDEDORA, conforme modalidades de planos descritas
        neste instrumento.
      </p>

      <p>
        1.2. As PARTES reconhecem expressamente que os royalties aqui descritos
        mantêm natureza estritamente comercial, oriundos da divisão de
        resultados das operações minerais, não constituindo rendimento
        financeiro, promessa de retorno, percentual fixo garantido, aplicação
        financeira ou valor mobiliário.
      </p>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        CLÁUSULA SEGUNDA – DA DIVISÃO DE ROYALTIES MENSAIS E MODELOS DE SAQUE
        COM A CAIXA DE OURO GOLDEN BOX
      </p>

      <p>
        Ficam instituídos os seguintes modelos operacionais de distribuição dos
        royalties, conforme opção contratada pelo ADQUIRENTE:
      </p>

      <p style={{ fontWeight: "bold", marginLeft: "10px" }}>
        I – PLANO TRIMESTRAL – SAQUE TRIMESTRAL
      </p>
      <ul style={{ listStyle: "lower-alpha", marginLeft: "30px" }}>
        <li>
          Acúmulo mensal de royalties operacionais na proporção de 4,1%,
          calculados sobre a base operacional interna da VENDEDORA;
        </li>
        <li>Saque trimestral correspondente ao acumulado de 12,3%;</li>
        <li>Acúmulo anual de royalties equivalente a 49,2%;</li>
        <li>
          Consideradas as operações, ciclos produtivos e distribuição ao longo
          dos 36 (trinta e seis) meses do contrato, o total acumulado estimado
          ao final do contrato poderá atingir até 150%, observado o desempenho
          operacional e comercial das atividades minerais.
        </li>
        <li>
          Saques sempre efetuados nas janelas de saques com pagamentos sempre
          efetivados entre o primeiro dia útil do mês até o quinto dia útil do
          mês subsequente;
        </li>
      </ul>

      <p
        style={{
          fontWeight: "bold",
          marginLeft: "10px",
          marginTop: "15px",
        }}
      >
        II – PLANO MENSAL – SAQUE MENSAL COM BENEFÍCIO EXTRA DE 1%
      </p>
      <ul style={{ listStyle: "lower-alpha", marginLeft: "30px" }}>
        <li>
          Disponibilização de benefício extra com saque mensal de 1%, de forma
          destacada da valorização operacional principal;
        </li>
        <li>Saque mensal do benefício extra de 1%, totalizando 12% ao ano;</li>
        <li>
          Benefício extra total estimado em 36% ao longo dos 36 (trinta e seis)
          meses;
        </li>
        <li>
          Considerada a soma entre a valorização operacional principal e os
          benefícios extras, o total consolidado estimado poderá alcançar até
          186% ao final do contrato, condicionado aos resultados efetivos das
          operações minerais.
        </li>
        <li>
          Saques sempre efetuados nas janelas de saques com pagamentos sempre
          efetivados entre o primeiro dia útil do mês até o quinto dia útil do
          mês subsequente;
        </li>
      </ul>

      <p
        style={{
          fontWeight: "bold",
          marginLeft: "10px",
          marginTop: "15px",
        }}
      >
        III – PLANO TOTAL – SAQUE MENSAL COM BENEFÍCIO EXTRA DE 1,3% E ACÚMULO
        FINAL
      </p>
      <ul style={{ listStyle: "lower-alpha", marginLeft: "30px" }}>
        <li>
          Disponibilização de benefício extra mensal de 1,3% , de forma
          independente da valorização operacional principal;
        </li>
        <li>
          Saque mensal do benefício extra de 1,3%, totalizando 15,6% ao ano;
        </li>
        <li>
          Benefício extra total estimado em 46,8% ao longo do prazo contratual;
        </li>
        <li>
          O total consolidado estimado, somando-se a valorização principal
          acumulada ao longo do contrato com os benefícios extras, poderá
          alcançar até 196,8%, de acordo com a performance das operações
          minerais.
        </li>
        <li>
          Saques sempre efetuados nas janelas de saques com pagamentos sempre
          efetivados entre o primeiro dia útil do mês até o quinto dia útil do
          mês subsequente;
        </li>
      </ul>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        CLÁUSULA TERCEIRA – DA SEGREGAÇÃO ENTRE VALORIZAÇÃO PRINCIPAL E
        BENEFÍCIOS EXTRAS
      </p>

      <p style={{ fontWeight: "bold" }}>3.1. As PARTES reconhecem que:</p>
      <ul style={{ listStyle: "lower-alpha", marginLeft: "30px" }}>
        <li>
          A valorização operacional principal, variável entre 2,1 % a 4,1%,
          mantém sua característica de acúmulo com disponibilidade anual,
          conforme regras do contrato principal;
        </li>
        <li>
          Os benefícios extras mensais, nas proporções de 1,0 % ou 1,3%,
          constituem vantagens adicionais, lançadas de forma segregada,
          facultando ao ADQUIRENTE a possibilidade de saque mensal, conforme
          modalidade contratada;
        </li>
        <li>
          A segregação entre valorização principal e benefícios extras não
          altera a natureza jurídica do contrato, permanecendo ambos como
          participação nos resultados comerciais das operações minerais.
        </li>
        <li>
          A migração de planos para o ADQUIRENTE que estiver no plano trimestral
          poderá ser para o plano anual ou total, sendo que no momento da
          migração deverá escolher no sistema “A CAIXA DE OURO GOLDEN BOX MENSAL
          OU TOTAL”;
        </li>
        <li>
          O cliente que mudar de plano de saque de Royalties utilizando a Caixa
          de Ouro Golden Box, poderá mudar apenas uma única vez.
        </li>
      </ul>

      <p style={{ fontWeight: "bold", marginTop: "15px" }}>
        CLÁUSULA QUARTA – DA RATIFICAÇÃO
      </p>

      <p>
        4.1. Permanecem ratificadas e inalteradas todas as demais cláusulas do
        Contrato CPOM que não conflitam com o presente Termo Aditivo.
      </p>

      <p>
        4.2. Este Termo Aditivo passa a integrar o Contrato CPOM para todos os
        fins de direito, produzindo efeitos a partir de sua aceitação eletrônica
        pelo ADQUIRENTE.
      </p>

      <div style={{ marginTop: "30px" }}>
        <p>
          Balneário Camboriú/SC,{" "}
          <strong style={{ color: "#333" }}>{todayDate}</strong>.
        </p>

        <p style={{ marginTop: "15px" }}>
          VENDEDORA:{" "}
          <span style={{ fontWeight: "bold" }}>Holding Golden Brasil S.A.</span>
        </p>

        <p style={{ marginTop: "15px" }}>
          ADQUIRENTE:{" "}
          <strong style={{ color: "#D4AF37" }}>{userData?.username}</strong>
        </p>
        <p>
          CONTRATO VÍNCULADO:{" "}
          <strong style={{ color: "#D4AF37" }}>#{selectedContract?.id}</strong>
        </p>
      </div>
    </>
  );
}
